"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5659],{

/***/ 38100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AppError_AppError; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./src/AppError/error-prop-type.js
var error_prop_type = __webpack_require__(76965);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./src/routes.js
var routes = __webpack_require__(30233);
;// CONCATENATED MODULE: ./src/AppError/Error400.js






const Error400 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Bad Request"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry, you didn’t provide all mandatory inputs or provided data was incorrect.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
/* harmony default export */ var AppError_Error400 = (Error400);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/AppError/Error401.js







const Error401 = ()=>{
    const { asPath  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Not Authorized"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry. You are not authorized to access the requested resource.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: "".concat(routes/* default.auth.logout */.Z.auth.logout, "?returnUrl=").concat(encodeURIComponent(asPath)),
                        children: "sign in"
                    }),
                    " ",
                    "with a different account, or",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error401 = (Error401);

;// CONCATENATED MODULE: ./src/AppError/Error403.js






const Error403 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Not Permitted"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry, you don’t have sufficient permissions to access this resource.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
/* harmony default export */ var AppError_Error403 = (Error403);

;// CONCATENATED MODULE: ./src/AppError/Error404.js




const Error404 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Not Found"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: "We’re sorry. The requested resource was not found."
            })
        ]
    });
/* harmony default export */ var AppError_Error404 = (Error404);

;// CONCATENATED MODULE: ./src/AppError/Error500.js






const Error500 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Something went wrong"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry. Something has gone wrong with the application.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please try again later or",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
/* harmony default export */ var AppError_Error500 = (Error500);

;// CONCATENATED MODULE: ./src/AppError/Error503.js




const Error503 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Service Unavailable"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: "We’re sorry. We’re temporarily unavailable."
            })
        ]
    });
/* harmony default export */ var AppError_Error503 = (Error503);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(89032);
;// CONCATENATED MODULE: ./src/AppError/ErrorDetails.js






const ErrorDetails = (param)=>/*#__PURE__*/ {
    let { error  } = param;
    return (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
        mx: true,
        md: 10,
        lg: 8,
        center: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
            utility: {
                radius: 6,
                bgColor: "black"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: " text-color-white px-5 py-5",
                children: JSON.stringify(error, null, 2)
            })
        })
    });
};
ErrorDetails.propTypes = {
    error: error_prop_type/* default */.Z
};
/* harmony default export */ var AppError_ErrorDetails = (config/* publicConfig.DEBUG_MODE */.mn.DEBUG_MODE ? ErrorDetails : ()=>null);

// EXTERNAL MODULE: ./src/AppError/ErrorLayout.js
var ErrorLayout = __webpack_require__(59093);
// EXTERNAL MODULE: ./src/sentry.js + 68 modules
var sentry = __webpack_require__(47950);
;// CONCATENATED MODULE: ./src/AppError/AppError.js














const errorComponents = {
    400: AppError_Error400,
    401: AppError_Error401,
    403: AppError_Error403,
    404: AppError_Error404,
    503: AppError_Error503
};
const AppError = (param)=>{
    let { error , Layout =ErrorLayout/* default */.Z , ...props } = param;
    const { code  } = error;
    const ErrorComponent = errorComponents[code] || AppError_Error500;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
        extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_ErrorDetails, {
            error: error
        }),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent, {
            error: error
        })
    });
};
AppError.getInitialProps = (context)=>{
    const { err , res  } = context;
    const error = ApplicationError/* default.of */.Z.of(err !== null && err !== void 0 ? err : {});
    if (res) {
        res.statusCode = error.code;
    }
    (0,sentry/* notifySentry */.Yw)(err, context);
    if (error.code >= 500 && error.code !== 503 && error.originalError != null) throw error.originalError;
    return {
        error: error.toSerializable()
    };
};
AppError.propTypes = {
    error: error_prop_type/* default */.Z,
    Layout: prop_types.elementType
};
/* harmony default export */ var AppError_AppError = (AppError);


/***/ }),

/***/ 59093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87385);
/* harmony import */ var _insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93512);
/* harmony import */ var _SiteLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26485);






/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode }>} */ const ErrorLayout = (param)=>/*#__PURE__*/ {
    let { children , extra  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_SiteLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        isWrapper: false,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: children
            }),
            extra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                spacing: {
                    pt: 9,
                    pb: 18,
                    md: {
                        pt: 9,
                        pb: 18
                    }
                },
                children: extra
            })
        ]
    });
};
ErrorLayout.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node,
    extra: prop_types__WEBPACK_IMPORTED_MODULE_5__.node
};
/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode, isAuthorized: boolean }>} */ const ErrorLayoutPure = (param)=>/*#__PURE__*/ {
    let { children , extra , isAuthorized  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_SiteLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Pure */ .Z.Pure, {
        isAuthorized: isAuthorized,
        isWrapper: false,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: children
            }),
            extra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                spacing: {
                    pt: 9,
                    pb: 18,
                    md: {
                        pt: 9,
                        pb: 18
                    }
                },
                children: extra
            })
        ]
    });
};
ErrorLayoutPure.propTypes = {
    ...ErrorLayout.propTypes,
    isAuthorized: prop_types__WEBPACK_IMPORTED_MODULE_5__.bool
};
ErrorLayout.Pure = ErrorLayoutPure;
/* harmony default export */ __webpack_exports__["Z"] = (ErrorLayout);


/***/ }),

/***/ 76965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ((0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
    code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
    message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
    stack: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.arrayOf)(prop_types__WEBPACK_IMPORTED_MODULE_0__.string),
    originalError: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        name: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
        code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
        message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string
    })
}));


/***/ }),

/***/ 71802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10455);
/* harmony import */ var _AppError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38100);




const withErrorHandling = (Component)=>{
    const WithErrorHandling = (param)=>{
        let { error , ...props } = param;
        if (error == null) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                ...props
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            error: error
        });
    };
    Object.assign(WithErrorHandling, Component);
    WithErrorHandling.propTypes = _AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes;
    WithErrorHandling.getInitialProps = (context, container)=>{
        try {
            const props = Component.getInitialProps ? Component.getInitialProps(context, container) : {};
            return (0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_3__/* .isPromise */ .tI)(props) ? props.catch((err)=>{
                return _AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getInitialProps */ .Z.getInitialProps({
                    ...context,
                    err
                }, container);
            }) : props;
        } catch (err) {
            return _AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getInitialProps */ .Z.getInitialProps({
                ...context,
                err
            }, container);
        }
    };
    return WithErrorHandling;
};
/* harmony default export */ __webpack_exports__["Z"] = (withErrorHandling);


/***/ }),

/***/ 26485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _insightfulscience_atomic_react_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71412);
/* harmony import */ var _SiteFooter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49478);
/* harmony import */ var _SiteHeader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5255);
/* harmony import */ var _services_authService_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11969);







const SiteLayoutPure = (param)=>{
    let { bodyClassName ="" , footerClassName ="" , children , isAuthorized , isWrapper =true , headerClassName , HeaderComponent =_SiteHeader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        isWrapper: isWrapper,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Header */ .Z.Header, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HeaderComponent, {
                    ...props,
                    isAuthorized: true,
                    className: headerClassName
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Body */ .Z.Body, {
                className: bodyClassName,
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Footer */ .Z.Footer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SiteFooter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: footerClassName
                })
            })
        ]
    });
};
SiteLayoutPure.propTypes = {
    bodyClassName: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    footerClassName: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    headerClassName: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    isAuthorized: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isWrapper: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node,
    hero: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    HeaderComponent: prop_types__WEBPACK_IMPORTED_MODULE_6__.elementType
};
const SiteLayout = (props)=>{
    const isAuthorized = (0,_services_authService_hooks__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SiteLayoutPure, {
        ...props,
        isAuthorized: isAuthorized
    });
};
SiteLayout.Pure = SiteLayoutPure;
/* harmony default export */ __webpack_exports__["Z"] = (SiteLayout);


/***/ }),

/***/ 33347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H5": function() { return /* binding */ reload; },
/* harmony export */   "SS": function() { return /* binding */ navToPath; },
/* harmony export */   "pR": function() { return /* binding */ gotoPath; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

const navToPath = function(path, as) {
    let action = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "push";
    return (next_router__WEBPACK_IMPORTED_MODULE_0___default())[action](path, as);
};
const gotoPath = (path, as, action)=>()=>navToPath(path, as, action);
const reload = ()=>next_router__WEBPACK_IMPORTED_MODULE_0___default().replace(window.location.href);


/***/ }),

/***/ 77637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_Alert__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3074);
/* harmony import */ var _insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73972);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);





const FlashErrorMessage = (param)=>/*#__PURE__*/ {
    let { text  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Alert__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        status: "error",
        className: "mb-6",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            Tag: "span",
            children: text
        })
    });
};
FlashErrorMessage.propTypes = {
    text: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (FlashErrorMessage);


/***/ }),

/***/ 3074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports AlertRow, AlertLink */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42866);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74229);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25522);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2349);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7820);










const AlertRow = (param)=>/*#__PURE__*/ {
    let { sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_6__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_7__/* .spacingProps */ .tF
    } , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        sx: {
            fontSize: "m",
            ...(0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(sx)
        },
        spacing: {
            my: 0,
            ...(0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(spacing)
        },
        ...props,
        children: children
    });
};
AlertRow.propTypes = {
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_6__/* .sxPropTypes */ .I1,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_7__/* .spacingPropTypes */ .Xj,
    isLast: prop_types__WEBPACK_IMPORTED_MODULE_9__.bool,
    ..._Paragraph__WEBPACK_IMPORTED_MODULE_4__/* ["default"].propTypes */ .Z.propTypes
};
const AlertLink = (param)=>/*#__PURE__*/ {
    let { href , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        href: href,
        className: "alert__link",
        ...props,
        children: children
    });
};
AlertLink.propTypes = {
    ..._Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
const Alert = (param)=>{
    let { title ="" , status ="success" , className ="" , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("alert", "alert--".concat(status), className),
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                Tag: "h3",
                className: "alert__title",
                children: title
            }),
            children
        ]
    });
};
Alert.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_9__.node,
    status: (0,prop_types__WEBPACK_IMPORTED_MODULE_9__.oneOf)([
        "default",
        "success",
        "error",
        "warning"
    ]),
    className: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_9__.node.isRequired
};
Alert.Row = AlertRow;
Alert.Link = AlertLink;
/* harmony default export */ __webpack_exports__["ZP"] = (Alert);


/***/ }),

/***/ 77915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10455);

/**
 * Type `SyncType<T>` - Type extracts type packed into the Promise
 *
 * @template T
 * @typedef {T extends Promise<infer Packed> ? Packed : T} SyncType
 */ const packToBuf = (buffer, field)=>(result)=>{
        // eslint-disable-next-line no-param-reassign
        buffer[field] = result;
        return buffer;
    };
const resolveToBuffer = (param)=>{
    let [field, resolver] = param;
    return (args, buffer)=>{
        try {
            const result = resolver(...args);
            const pack = packToBuf(buffer, field);
            return (0,___WEBPACK_IMPORTED_MODULE_0__/* .isPromise */ .tI)(result) ? result.then(pack) : pack(result);
        } catch (err) {
            return Promise.reject(err);
        }
    };
};
const resolversWrapper = (resolvers)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        const buffer = {};
        const promises = resolvers.map((0,___WEBPACK_IMPORTED_MODULE_0__/* .call */ .RE)(args, buffer));
        return Promise.all(promises).then(()=>buffer);
    };
const prepareResolvers = (param)=>{
    let [field, resolver] = param;
    return resolveToBuffer([
        field,
        (0,___WEBPACK_IMPORTED_MODULE_0__/* .ensureFunc */ .KX)(resolver, ()=>resolver)
    ]);
};
/**
 * Creates new functions that returns Promise resolving to an object with
 * values returned by functions specified for correspondent fields of argument
 * object
 *
 * @example
 * const fn = propsResolver({
 * 	x: () => 1,
 *  y: () => 2,
 * });
 * fn().then(console.log); // prints: { x: 1, y: 2 }
 *
 * @type {
 	<
		A extends any[],
		M extends { [p in string]: (...args: any[]) => any }
	>(resolversMap: M) => (...args: A) => Promise<{ [k in keyof M]: SyncType<ReturnType<M[k]>> }>
 }
 */ const propsResolver = (resolversMap)=>resolversWrapper(Object.entries(resolversMap).map(prepareResolvers));
/* harmony default export */ __webpack_exports__["Z"] = (propsResolver);


/***/ })

}]);